import { render, staticRenderFns } from "./Order2.vue?vue&type=template&id=1abd9751&scoped=true&"
import script from "./Order2.vue?vue&type=script&lang=js&"
export * from "./Order2.vue?vue&type=script&lang=js&"
import style0 from "./Order2.vue?vue&type=style&index=0&id=1abd9751&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abd9751",
  null
  
)

export default component.exports